import { Box, Stack } from '@mui/material';
import Header from '../Header';
import { memo } from 'react';
import SideMenu from '../SideMenu';

type LayoutProps = {
  children?: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <Stack direction="row">
      <SideMenu />
      <Box sx={{ flexGrow: 1 }}>
        <Header />
        <Box component="main" sx={{ p: { xs: 0, sm: 3 } }}>
          {children}
        </Box>
      </Box>
    </Stack>
  );
};

export default memo(Layout);
